import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { useCheckoutThemeContext } from "repoV2/features/CheckoutPages/modules/CheckoutThemeContextProvider";
import { colorWithAlpha } from "repoV2/features/Common/modules/Colors/utils/rgbColors.utils";
import styles from "./PaymentCard.module.scss";

export interface IPaymentCard {
    title: string;
    subTitle: string;
    priceText: string | JSX.Element | JSX.Element[];
    isCardSelected: boolean;
    onClick: () => void;
    children?: JSX.Element | JSX.Element[];
}

const PaymentCard = (props: IPaymentCard) => {
    const { title, subTitle, priceText, isCardSelected, onClick, children } =
        props;

    const {
        colors: { color1 },
    } = useCheckoutThemeContext();

    return (
        <div
            className={classNames(
                styles.mainContainer,
                isCardSelected && styles.selectedCardStyle
            )}
            style={{
                ...(isCardSelected && {
                    backgroundColor: colorWithAlpha(color1, 0.1),
                }),
            }}
            onClick={onClick}
        >
            <div className={styles.innerContainer}>
                <div className={styles.titleTextContainer}>
                    <div className={styles.titleStyle}>{title}</div>
                    <div className={styles.subTitleStyle}>{subTitle}</div>
                </div>
                <div>{priceText}</div>
            </div>
            {children}
        </div>
    );
};

export default PaymentCard;
